var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FooterBar',{attrs:{"link-items":_setup.linkItems,"hide-a11y-link":"","hide-sitemap-link":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }